// extracted by mini-css-extract-plugin
export default {"task":"GHGqt","task_content":"lpumR","fennecs":"VCtAD","description":"xJJ0o"};